import { gql } from "graphql-tag";

export const query = gql`
  query FeatureFlagDashboard {
    featureFlags {
      id
      name
      globalEnabled
      globalDefaultEnabled
    }

    propertyFeatureFlags {
      id
      enabled
      propertyId
      featureId
    }

    properties {
      id
      name
    }
  }
`;

export const updateFeatureFlag = gql`
  mutation UpdateFeatureFlag($id: ID!, $globalEnabled: Boolean!, $globalDefaultEnabled: Boolean!) {
    updateFeatureFlag(
      id: $id
      globalEnabled: $globalEnabled
      globalDefaultEnabled: $globalDefaultEnabled
    ) {
      id
    }
  }
`;

export const deleteFeatureFlag = gql`
  mutation DeleteFeatureFlag($id: ID!) {
    deleteFeatureFlag(id: $id)
  }
`;

export const createPropertyFeatureFlag = gql`
  mutation CreatePropertyFeatureFlag($featureId: ID!, $propertyId: ID!, $enabled: Boolean!) {
    createPropertyFeatureFlag(featureId: $featureId, propertyId: $propertyId, enabled: $enabled) {
      id
    }
  }
`;

export const updatePropertyFeatureFlag = gql`
  mutation UpdatePropertyFeatureFlag($id: ID!, $enabled: Boolean!) {
    updatePropertyFeatureFlag(id: $id, enabled: $enabled) {
      id
    }
  }
`;

export const deletePropertyFeatureFlag = gql`
  mutation DeletePropertyFeatureFlag($id: ID!) {
    deletePropertyFeatureFlag(id: $id) {
      id
    }
  }
`;
